<template>
  <b-modal @hide="createModalClose" id="facilityModal" ref="facilityModal" :title="$t('工程情報登録')" size="xl">
    <b-container fluid>
      <div class="form-group row">
        <label for="" class="col-sm-3 col-form-label">
          {{ $t("工程/設備名") }}
          <span class="text-danger">&nbsp;{{ $t("※必須") }}</span>
        </label>
        <div class="col-sm-9">
          <input v-model="create.form.name" type="text" class="form-control" />
        </div>
      </div>
      <div class="form-group row">
        <label for="" class="col-sm-3 col-form-label">
          {{ $t("工程管理番号") }}
        </label>
        <div class="col-sm-9">
          <input v-model="create.form.code" type="text" class="form-control" />
        </div>
      </div>
      <div class="form-group row">
        <label for="displayColor" class="col-sm-3 col-form-label">
          <tooltip
            :text="$t('工程表示色')"
            icon="fa-question-circle"
            position="position-left-top"
            :msg="$t('工程'+this.$appConfig.tooltipMessages.setDidplayColorOnGanttChart)"
            :msgMaxLength="$t('工程'+this.$appConfig.tooltipMessages.setDidplayColorOnGanttChart).length"
            :isDisplayColorBtn="false"
          ></tooltip>
        </label>
        <div class="col-sm-9">
          <button
            id="displayColor"
            type="button"
            class="form-control btn btn-color-circle"
            :style="displayColorStyle"
            @click="displayColorModalOpen()"
          >
          </button>
          <label class="col-sm-4 col-form-label">
            {{ $t(displayColorName) }}
          </label>
        </div>
      </div>
      <div class="form-group row mb-0">
        <label class="col-sm-3 col-form-label">
          {{ $t("工程計画ルール") }}
          <span class="text-danger">&nbsp;{{ $t("※必須") }}</span>
          <span class="float-right">{{ $t("加工区分") }}</span>
        </label>
        <div class="col-sm-9">
          <div class="col-form-label">
            <label for="id_division_0">
              <input type="radio" v-model="create.form.division" name="division" value="auto" id="id_division_0">
                {{ $t("自動加工: 段取中は作業者は他の工程を担当できない。加工中は作業者は他の工程を担当できる") }}
            </label>
            <br>
            <label for="id_division_1">
              <input type="radio" v-model="create.form.division" name="division" value="manual" id="id_division_1">
                {{ $t("手動加工: 段取中・加工中は作業者は他の工程を担当できない") }}
            </label>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-sm-3 col-form-label pt-4">
          <span class="float-right">{{ $t("稼働時間") }}</span>
        </label>
        <div class="col-sm-9">
          <div class="col-form-label">
            <q-toggle
              v-model="create.form.isOperativeBreakTime"
            >
              <span v-if="create.form.isOperativeBreakTime">
                {{ $t('会社・工場・部署情報で設定した休憩時間に稼働する') }}
              </span>
              <span v-else class="off">
                {{ $t('会社・工場・部署情報で設定した休憩時間に稼働する') }}
              </span>
            </q-toggle>
            <br>
            <q-toggle
              v-model="create.form.isOperativeNonRegularTime"
            >
              <span v-if="create.form.isOperativeNonRegularTime">
                {{ $t('会社・工場・部署情報で設定した稼働時間外に稼働する') }}
              </span>
              <span v-else class="off">
                {{ $t('会社・工場・部署情報で設定した稼働時間外に稼働する') }}
              </span>
            </q-toggle>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <label for="" class="col-sm-3 col-form-label">
          {{ $t("工程区分") }}
          <span class="text-danger">&nbsp;{{ $t("※必須") }}</span>
        </label>
        <div class="col-sm-9">
          <div class="processKindBox" v-for="parentProcessKind in this.processKinds" :key="parentProcessKind.id">
            <h3 class="processKindTitle">{{ $t(parentProcessKind.messageKey) }}</h3>
            <span v-for="processKindChild in parentProcessKind.datas" :key="processKindChild.id">
              <label class="ml-4" :for="'id_pc_' + processKindChild.id">
                <input type="radio" v-model="create.form.processKindId" name="processKind" :value="processKindChild.id" :id="'id_pc_' + processKindChild.id">
                  {{ $t(processKindChild.messageKey) }}
              </label>
            </span>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <label for="" class="col-sm-3 col-form-label">
          {{ $t("時間単価[円/時間]") }}
        </label>
        <div class="col-sm-9">
          <input type="number" style="width:120px;text-align:left;" v-model.number="create.form.hourPrice" name="unit_price" value="0" class="form-control input-sm" id="id_unit_price">
        </div>
      </div>
      <div class="form-group row">
        <label for="" class="col-sm-3 col-form-label">
          {{ $t("工場") }}
        </label>
        <div class="col-sm-9">
          <select class="form-control" v-model="create.form.site">
            <option selected></option>
            <template v-for="(item ,index) in mixinSpacesListDisplay('site')" :keyed="`site-${index}`">
              <option :value="item.id" :key="`site-${index}`">{{ item.name }}</option>
            </template>
          </select>
        </div>
      </div>
      <div class="form-group row">
        <label for="" class="col-sm-3 col-form-label">
          {{ $t("部署") }}
        </label>
        <div class="col-sm-9">
          <select class="form-control" v-model="create.form.dep">
            <option value=""></option>
            <template v-for="(item ,index) in mixinSpacesListDisplay('dep')" :keyed="`dep-${index}`">
              <option :value="item.id" :key="`dep-${index}`">{{ item.name }}</option>
            </template>
          </select>
        </div>
      </div>
      <div class="form-group row">
        <label for="" class="col-sm-3 col-form-label">
          {{ $t("工程IoT機器") }}
        </label>
        <div class="col-sm-9">
          <input type="text" v-model="create.form.iot1" placeholder="00:00:5E:00:53:00" class="form-control mb-3" />
          <input type="text" v-model="create.form.iot2" placeholder="00:00:5E:00:53:00" class="form-control mb-3" />
          <input type="text" v-model="create.form.iot3" placeholder="00:00:5E:00:53:00" class="form-control mb-3" />
          <input type="text" v-model="create.form.iot4" placeholder="00:00:5E:00:53:00" class="form-control mb-3" />
          <input type="text" v-model="create.form.iot5" placeholder="00:00:5E:00:53:00" class="form-control mb-3" />
        </div>
      </div>
    </b-container>
    <template v-slot:modal-footer>
      <p class="text-danger text-center" v-if="create.error">{{ create.error }}</p>
      <button
        type="button"
        class="btn btn-light"
        @click="createModalClose()"
        v-if="!create.confirm"
        :disabled="create.registration"
      >{{ $t("キャンセル") }}</button>
      <button
        type="button"
        class="btn btn-success"
        @click="createRegister($event)"
        :disabled="create.registration"
      >
        <div
          class="d-flex justify-content-center align-items-center mr-3"
          v-if="create.registration"
        >
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        </div>
        {{ $t("登録") }}
      </button>
    </template>
    <selectDisplayColorModal
      ref="selectDisplayColorModal"
      flg="modal-display-color modal-display-color-process"
      :displayColorStyle="this.displayColorStyle"
      @modal-close="setDisplayColor">
    </selectDisplayColorModal>
  </b-modal>
</template>

<script>
import config from '@/config'
import { mapGetters } from 'vuex'
import selectDisplayColorModal from '@/components/selectDisplayColorModal.vue'
import tooltip from '@/components/tooltip.vue'

const defaultCreate = {
  load: false,
  form: {
    id: null,
    name: '',
    code: '',
    division: '',
    isOperativeBreakTime: true,
    isOperativeNonRegularTime: false,
    site: null,
    dep: null,
    hourPrice: null,
    iot1: '',
    iot2: '',
    iot3: '',
    iot4: '',
    iot5: '',
    displayColor: config.processDisplayColors.green.val,
    processKindId: null,
    userIds: [],
    sort: null,
  },
  list: [],
  registration: false,
  error: '',
}

export default {
  data() {
    return {
      displayColorName: config.processDisplayColors.green.name,
      displayColorStyle: {'background-color': '', 'border-color': ''},
      create: this.mixin_deepcopy(defaultCreate),
      processKinds: [],
      master: {},
    }
  },
  components: {
      tooltip,
      selectDisplayColorModal,
  },
  methods: {
    // モーダルを開いたときの処理
    createModalOpen(item = {}, processKinds, master) {
      const copy = this.mixin_deepcopy(item)
      if (copy.id) {
        this.create.form = copy
      }
      this.updateDisplayColor()
      this.processKinds = processKinds // 工程区分
      this.master = master // 工程区分
      this.$refs.facilityModal.show()
    },
    destroyModal() {
      this.create = this.mixin_deepcopy(defaultCreate)
      this.$refs.facilityModal.hide()
    },
    createModalClose() {
      this.destroyModal()
      this.$emit('modal-close')
    },
    async createRegister() {
      if (this.create.form.name === null || this.create.form.name === undefined) {
        this.create.error = this.$t('工程/設備名') + this.$t('必須メッセージ')
        return
      } else if (this.create.form.division !== 'auto' && this.create.form.division !== 'manual') {
        this.create.error = this.$t('加工区分') + this.$t('必須メッセージ')
        return
      } else if (this.create.form.processKindId === null || this.create.form.processKindId === undefined) {
        this.create.error = this.$t('工程区分') + this.$t('必須メッセージ')
        return
      } else {
        this.create.error = ''
      }
      this.create.registering = true
      let method = 'post'
      const params = {}
      if (this.create.form.id) {
        method = 'put'
        params['id'] = this.create.form.id
      }
      params['code'] = this.create.form.code || ''
      params['name'] = this.create.form.name
      params['division'] = this.create.form.division
      params['isOperativeBreakTime'] = this.create.form.isOperativeBreakTime
      params['isOperativeNonRegularTime'] = this.create.form.isOperativeNonRegularTime
      params['site'] = this.create.form.site || null
      params['dep'] = this.create.form.dep || null
      params['hourPrice'] = this.create.form.hourPrice || (this.create.form.hourPrice === 0 ? 0 : null)
      params['iot1'] = this.create.form.iot1 || ''
      params['iot2'] = this.create.form.iot2 || ''
      params['iot3'] = this.create.form.iot3 || ''
      params['iot4'] = this.create.form.iot4 || ''
      params['iot5'] = this.create.form.iot5 || ''
      params['displayColor'] = this.create.form.displayColor
      params['processKindId'] = this.create.form.processKindId
      params['sort'] = this.create.form.sort || (this.create.form.sort === 0 ? 0 : await this.getHighestProcessesSortOrder() + 1)
      params['userIds'] = this.create.form.userIds || []
      try {
        await this.$axios({
          method: method,
          headers: {
            Authorization: this.authorization ? this.authorization : null,
          },
          url: `${this.$appConfig.CommonApiUrl}/process`,
          data: params,
        })
        this.$toasted.success(this.$t('データ登録完了メッセージ'))
        this.destroyModal()
        this.$emit('registed')
      } catch (err) {
        this.$toasted.show('データ登録エラーメッセージ')
        this.create.registering = false
      }

    },
    displayColorModalOpen() {
      this.$refs.selectDisplayColorModal.modalOpen()
    },
    updateDisplayColor() {
      this.displayColorName = Object.values(config.processDisplayColors).find(color => this.create.form.displayColor === color.val)?.name
      this.setDisplayColorStyle()
    },
    setDisplayColor(data) {
      if (data.hex && data.name) {
        this.create.form.displayColor = data.hex
        this.displayColorName = data.name
        this.setDisplayColorStyle()
      }
    },
    setDisplayColorStyle() {
      this.displayColorStyle = {'background-color': this.create.form.displayColor, 'border-color': this.create.form.displayColor}
    },
    async getHighestProcessesSortOrder() {
      // get processes info
      const response = await this.$axios.get(
        `${this.$appConfig.CommonApiUrl}/processes`,
        {
          headers: {
            Authorization: this.authorization ? this.authorization : null,
          },
          params: {
            limit: 600,
          },
        },
      )
      // filter to get only [sort] data
      const orderList = response.data.filter((data) => data.sort).map((item)=> {
        return item.sort
      })
      // return current highest sort order
      return orderList.length < 1 ? 0 : Math.max.apply(0, orderList)
    },
  },
  computed: {
    ...mapGetters({
      authorization: 'auth/authorization',
    }),
  },
}
</script>

<style lang="scss" scoped>
#facilityModal {
  .processKindBox{
    padding-bottom: 15px;
  }
  .processKindTitle{
    font-size: 16px;
    font-weight: bold;
    border-bottom:1px solid #ccc;
    padding-bottom: 5px;
    margin-bottom: 10px;
  }
}
.off {
  color: #cdcdcd;
}
</style>
